<template>
    <base-modal title="Create new topic" :visible="true" @close="$emit('close')">
        <topics-form :loading="create.loading" @submit="submit" @cancel="$emit('close')"/>
    </base-modal>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import TopicsForm from './TopicsForm.vue';

export default {
    name: 'TopicsCreateModal',
    components: { TopicsForm },
    props: ['space'],
    computed: {
        ...mapState('topics', ['create']),
        ...mapGetters('topics', ['by_id']),
    },
    methods: {
        async submit(data) {
            const topic = await this.$store.dispatch('topics/create', {
                space_id: this.space.id,
                data,
            });
            this.$emit('close');
            this.$emit('created', topic);
            await this.$store.dispatch('topics/list', { space_id: this.space.id });
        },
    },
};
</script>
